import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-package-details',
  templateUrl: './package-details.component.html',
  styleUrls: ['./package-details.component.css']
})
export class PackageDetailsComponent implements OnInit {

  @Input() package;
  data = {
    destination: 'Madrid',
    packageType: 'Premium'
  }
  
  constructor() { }

  ngOnInit(): void {
    
  }

  getData(){
    return this.data;
  }

}
